export default function getMasterProducts(products) {
  if (products === null || products === undefined) return []
  return products.filter(product => product.is_master === true)
}
